@if (product(); as product) {
    <div class="flex gap-1">
        @if (product.isSoldOut) {
            <div class="badge bg-gray-400">
                <p>SOLDOUT</p>
            </div>
        }

        @if (product.isNew) {
            <div class="badge bg-[#FF860E]">
                <p>NEW</p>
            </div>
        }

        @if (product.isBest) {
            <div class="badge bg-[#62CC5D]">
                <p>BEST</p>
            </div>
        }

        @if (product.discountPrice) {
            <div class="badge bg-primary">
                <p>SALE</p>
            </div>
        }
    </div>
}
